import { alpha, Stack } from "@mui/material";
import { ReactNode, useEffect } from "react";
import { useAuth } from "@/hook";
import WaitFetchProfile from "@/components/pages/wait-fetch-profile/loading-check-usr-token";

const CheckUserToken = ({ children }: { children: ReactNode }) => {
  const { refreshUser, loading, isLoggedIn } = useAuth();

  useEffect(() => {
    if(!isLoggedIn){
      refreshUser();
    }
  }, []);

  return (
    <Stack>
      {loading ? (
        <Stack
          sx={{
            backgroundColor: (t) => alpha(t.palette.primary.main, 0.07),
            minHeight: "100vh",
          }}
          alignItems="center"
          justifyContent="center"
        >
          <WaitFetchProfile />
        </Stack>
      ) : (
        children
      )}
    </Stack>
  );
};

export default CheckUserToken;
